import { createFileRoute, notFound } from "@tanstack/react-router";
import { EmbedPreCheckoutView, isSlug } from "@/components/checkout/EmbedPreCheckoutView";

type Tipo = "unica" | "assinatura";

export const Route = createFileRoute("/embed/pre-checkout/$slug")({
  validateSearch: (search: Record<string, unknown>) => ({
    tipo: (search.tipo === "assinatura" ? "assinatura" : "unica") as Tipo,
  }),
  head: ({ params }) => ({
    meta: [
      { title: `Finalizar matrícula · ${params.slug} · Fisio em Ortopedia` },
      { name: "robots", content: "noindex,nofollow" },
    ],
    links: [
      { rel: "preconnect", href: "https://pfzkgqaoufsyvhvwzqtk.supabase.co", crossOrigin: "anonymous" },
    ],
  }),
  component: EmbedPreCheckoutPage,
});

function EmbedPreCheckoutPage() {
  const { slug } = Route.useParams();
  const { tipo } = Route.useSearch();
  if (!isSlug(slug)) throw notFound();
  return <EmbedPreCheckoutView slug={slug} tipo={tipo} variant="padrao" />;
}
